import { range } from "lodash";
import {
  formatDate,
  formatNumber,
  getDbDateFormat,
  getGlobalMessage,
  getTextFromHTML,
  openPage,
} from "../../../utilities/commonHelpers";
import { processAdjustments } from "../../../services/order/orderService";
import SidePanel from "../../../shared/SidePanel";
import Modal from "../../../shared/Modal";
import { Page_Orders_Landing, Page_PA_Orders_Landing } from "../../../utilities/ReferenceUrls";
export const lineItemsData = {
  CustomerId: 1,
  EnvironmentType: "BROWSER", //Display Ads ? Browser : VIDEO_PLAYER which is adType
  LineItemType: "STANDARD",
  LineItemName: "Mirabel LineItem #1",
  RateCardID: 8,
  Size: "123x456", //only size/ratio without name
  CustomTargeting: "",
  Price: 0,
  CPM: 10.0,
  Qty: 1000,
  CardRate: 10000,
  Net: 10000,
  Gross: 10000.0,
  ProdCharge: 0,
  Discount: 3,
  Notes: "Line Item Notes",
  StartDate: "01/15/2021 00:00:00",
  EndDate: "01/15/2022 00:00:00",
  Impressions: 100,
  CreatedBy: 1,
  UpdatedBy: 1,
  PALineItemId: -1, //-1 when creating
  MMLineItemId: -1, //-1 when creating
  DateAdded: "01/15/2021 00:00:00",
  DateModified: "01/15/2021 00:00:00",
  OrderId: -1,
  PAOrderId: -1, //Can be -1 for line item created from local orders
  CostType: "CPM", //RateCard name
  Priority: 4, //LineType dropdown number
  Status: "DRAFT",
  SelectedTaxIDs: "",
  SelectedTaxGroupIDs: "", //For Taxes
};

export const convertNumberToLocaleString = (number) => {
  return number.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

export const LocaleStringToNumber = (localeNumberString) => {
  return parseFloat(localeNumberString.replace(/,/g, ""));
};

export const PRODUCT_TYPE_FOR_PROGRAMMATIC_ADS = "programmaticad";
export const PRODUCT_TYPE_FOR_BSA_ADS = "broadstreetad";

export const RateCardTypes = {
  FlatRate: 0,
  CPM: 1,
  Quantity: 2,
  TieredCPM: 3,
  TieredPriceQuantity: 4,
  PrintCPM: 5,
  TieredPrintCPM: 6,
  TieredFlatRate: 7,
};
export const AgencyDiscountType = {
  Gross: {
    Code: 0,
    Description: "Gross",
  },
  NetPlus: {
    Code: 1,
    Description: "Net+",
  },
  Net: {
    Code: 2,
    Description: "Net",
  },
};

export const getAgencyDiscountType = (agencyDiscountType) => {
  switch (agencyDiscountType) {
    case AgencyDiscountType.NetPlus.Code:
      return { text: "Net+", formula: "[Gross = Net + (Net * Agency% / 100)]" };

    case AgencyDiscountType.Net.Code:
      return {
        text: "Net",
        formula: "[Gross = Net / ((100 - Agency%) / 100)]",
      };

    case AgencyDiscountType.Gross.Code:
    default:
      return {
        text: "Gross",
        formula: "[Net = Gross - (Gross * Agency% / 100)]",
      };
  }
};

export const getDefaultData = (subproducttypeid) => {
  switch (subproducttypeid) {
    case 1:
    case "Print":
    case 3:
    case "Digital":
      return {
        Product: { Display: "", Value: "" },
        Ratecard: { Display: "", Value: "" },
        BusinessUnit: { Display: "", Value: "" },
        Currency: { Display: "", Value: "" },
        Net: "0.00",
        Gross: "0.00",
        Barter: "",
        BaseRate: "0.00",
        ProductionCharge: "",
        CardRate: "",
        CPM: "0.00",
        Price: "",
        Notes: "",
        StartDate: "",
        EndDate: "",
        Impressions: 0,
        Quantity: "",
        ActualImpressions: "",
        TotalColumnInches: 0,
        AdSize: { Display: "", Value: "", OptionTag: {} },
        AdPosition: { Display: "", Value: "", OptionTag: {} },
        AdColor: { Display: "", Value: "-1" },
        SpecialSection: { Display: "", Value: "" },
        AdFrequency: { Display: "", Value: "-1" },
        AdColumn: { Display: null, Value: 0 },
        AdInch: { Display: null, Value: 0 },
        IsBleed: false,
        IsWithInEdit: false,
        IsAcrossEdit: false,
        IsRightHandOnly: false,
        CompPages: { Display: "", Value: 0 },
        ActualClicks: "",
        ActualQuantity: 0,
        ImpressionsActual: "",
        ActualVideoCompletions: "",
        ActualVideoStarts: 0,
        ActualViewableImpressions: 0,
        AdUnitSizes: [],
        CustomTargeting: [],
        AdUnitSizesSummary: "",
        CustomTargetingSummary: "",
        BillingInstallments: {},
        SharedJobJacketID: 0,
        InventoryList: [],
        SelectedIssueIDs: [],
      };
    default:
      return {
        Product: { Display: "", Value: "" },
        Ratecard: { Display: "", Value: "" },
        BusinessUnit: { Display: "", Value: "" },
        Currency: { Display: "", Value: "" },
        Net: "",
        Gross: "",
        Barter: "",
        BaseRate: "0.00",
        ProductionCharge: "",
        CardRate: "",
        CPM: "",
        Price: 0,
        Notes: "",
        StartDate: "",
        EndDate: "",
        Impressions: 0,
        Quantity: "",
        ActualImpressions: "",
        TotalColumnInches: "",
        AdSize: { Display: "", Value: "", OptionTag: {} },
        AdPosition: { Display: "", Value: "", OptionTag: {} },
        AdColor: { Display: "", Value: "" },
        SpecialSection: { Display: "", Value: "" },
        AdFrequency: { Display: "", Value: "" },
        AdColumn: { Display: "", Value: 0 },
        AdInch: { Display: "", Value: 0 },
        IsBleed: false,
        IsWithInEdit: false,
        IsAcrossEdit: false,
        IsRightHandOnly: false,
        CompPages: { Display: "", Value: 0 },
        ActualClicks: "",
        ActualQuantity: 0,
        ImpressionsActual: "",
        ActualVideoCompletions: "",
        ActualVideoStarts: 0,
        ActualViewableImpressions: 0,
        AdUnitSizes: [],
        CustomTargeting: [],
        AdUnitSizesSummary: "",
        CustomTargetingSummary: "",
        BillingInstallments: {},
        InventoryList: [],
        SelectedIssueIDs: [],
        Zones:[],
        Weight:{ Name: "", ID: 0 },
        DisplayType:{ Name: "", ID: 0 }
      };
  }
};

export const defaultInstallmentsData = {
  PAPaymentPlan: {
    ContainerID: -1,
    LineItemIds: "",
  },
  Installments: {},
};

// Split helper static data.
export const splitDropdownDefaultValue = {
  amount: 1,
  originalItem: 1,
  billing: 1,
};

export const splitOptions = [
  { Display: "Monthly (1st day)", Value: "mnuMonthly1stday" },
  { Display: "Bi-Weekly (1st & 15th)", Value: "mnuBiWeekly1st15th" },
  { Display: "Bi-Monthly (1st day)", Value: "mnuBiMonthly1stday" },
  { Display: "Quarterly (1st day)", Value: "mnuQuarterly1stday" },
  { Display: "Monthly", Value: "mnuMonthly" },
  { Display: "Weekly", Value: "mnuWeekly" },
  { Display: "Daily", Value: "mnuDaily" },
  { Display: "Make a Copy", Value: "mnuMakeACopy" },
];

export const splitDropdownData = {
  amount: [
    { Value: 1, Display: "Divide Card Rate Amount Equally" },
    { Value: 2, Display: "Keep Card Rate Amount the Same" },
  ],
  originalItem: [
    { Value: 1, Display: "Delete Original Item" },
    { Value: 2, Display: "Leave Original Item" },
  ],
  billing: [
    { Value: 1, Display: "Billing on Start Dates of New Items" },
    { Value: 2, Display: "Billing on Start Date of Original Item" },
  ],
};

export const InventoryCheckColumns = [
  { Header: "Ad Size", accessor: "AdSize" },
  { Header: "Product", accessor: "Product" },
  { Header: "Position", accessor: "Position" },
  { Header: "Issue", accessor: "IssueName" },
  { Header: "Status", accessor: "Status" },
  { Header: "Go To Report", accessor: "Custom" },
];

export const DaysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thurs", "Fri", "Sat"];
export const WeekDays = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
export const MonthDays = range(1, 32); // Generates an array [1, 2, 3, ..., 31]

export const issuesInstructionsTooltip = () => {
  return (
    <div style={{ lineHeight: "1.4", fontSize: "13px" }}>
      <p className="m-2">
        Use the issue selection tool to set the issue for this order or to
        create copies of it to multiple issues. There are a few different ways
        to select issues:
      </p>

      <ul style={{ listStyleType: "disc", padding: "0 6%" }}>
        <li>
          Click any row to select only that single issue, this clears out all
          other selections.
        </li>
        <li>
          Ctrl+Click on any row to add that to the list of selected issues.
        </li>
        <li>
          Shift+Click will select all issues between the 2 that were selected,
          this clears out all other selections
        </li>
        <li>
          Click on any of the check boxes to add or remove that issue to the
          list of selected issues.
        </li>
        <li>
          <p>Select by Date Range</p>
          <ul style={{ listStyleType: "circle", padding: "0 6%" }}>
            <li>
              This will select every issue that has an issue date between the
              dates.
            </li>
            <li>
              Choose a schedule to select all issues between the dates that land
              on the dates given by the selected frequency.
            </li>
          </ul>
        </li>
        <li>
          Remove all issues from the selections and start over by clicking the
          Clear Selections button.
        </li>
        <li>
          Click the Select Issues button to create the order and any copies for
          the selected issues.
        </li>
      </ul>
      <p className="m-2">Notes:</p>
      <ul style={{ listStyleType: "disc", padding: "0 6%" }}>
        <li>
          The list of issues is in ascending order by issue date, not issue
          name.
        </li>
        <li>
          Closed issues are not visible in this list. Contact your site admin
          for additions or edits to closed issues.
        </li>
        <li>
          When copies of the order are being made to multiple Products, a copy
          will be created for each selected available issue for each product.
        </li>
      </ul>
    </div>
  );
};

export const getShareJJLabel = (ProductType) => {
  switch (ProductType) {
    case 1:
      return "Shared Print Job Details.";
    case 3:
      return "Shared Digital Job Details.";
    default:
      return "Shared Job Details.";
  }
};

export const getShareJJLabelTooltip = (ProductType) => {
  switch (ProductType) {
    case 1:
      return (
        <>
          <p
            className="sub-header"
            style={{ textTransform: "none", marginBottom: "5px" }}
          >
            Shared Print Job Details.
          </p>
          <p>
            Create shared print job details for the orders being created. The
            shared print job details will allow the production team or user to
            gather ad material and manage the workflow in a single place for all
            the orders that are shared.
          </p>
        </>
      );
    case 3:
      return (
        <>
          <p
            className="sub-header"
            style={{ textTransform: "none", marginBottom: "5px" }}
          >
            Shared Digital Job Details.
          </p>
          <p>
            Create shared print job details for the orders being created. The
            shared print job details will allow the production team or user to
            gather ad material and manage the workflow in a single place for all
            the orders that are shared.
          </p>
        </>
      );
    default:
      return (
        <>
          <p
            className="sub-header"
            style={{ textTransform: "none", marginBottom: "5px" }}
          >
            Shared Job Details.
          </p>
          <p>
            Create shared Job Details for the orders being created. The shared
            Job Details will allow the production team or user to gather ad
            material and manage the workflow in a single place for all the
            orders that are shared.
          </p>
        </>
      );
  }
};

export const getShareJJCheckBoxText = (ProductType, OptionType) => {
  switch (ProductType) {
    case 1:
      if (OptionType === "MultiProducts") {
        return "Create shared print Job details for all orders of multiple products with the same issue. One Shared Job Jacket for each issue.";
      } else if (OptionType === "MultiIssues") {
        return "Create shared print Job details for all orders of all products & issues. One Shared Job Jacket for all orders.";
      } else {
        return "Create shared Job details for all orders with the same issue for each product. One share for each issue.";
      }
    case 3:
      if (OptionType === "MultiProducts") {
        return "Create shared digital Job details for all orders of multiple products with the same issue. One Shared Job Jacket for each issue.";
      } else if (OptionType === "MultiIssues") {
        return "Create shared digital Job details for all orders of all products & issues. One Shared Job Jacket for all orders.";
      } else {
        return "Create shared Job details for all orders for all products & issues. One shared job jacket.";
      }

    default:
      return "";
  }
};

export const classifiedsAcceptedFileTypes = [
  "jpg",
  "png",
  "gif",
  "jpeg",
  "pdf",
  "eps",
];

export const getAddSalesRepTooltip = () => {
  return (
    <>
      <p
        className="sub-header"
        style={{ textTransform: "none", marginBottom: "5px" }}
      >
        Add New Sales Rep
      </p>
      <p>
        Click here to split the ownership of this campaign between sales reps.
      </p>
    </>
  );
};

export const getResetSalesRepTooltip = () => {
  return (
    <>
      <p
        className="sub-header"
        style={{ textTransform: "none", marginBottom: "5px" }}
      >
        Cancel Add
      </p>
      <p> Cancel adding this rep split and reset the amounts.</p>
    </>
  );
};

export const AdjustmentOptions = {
  SelectAdjustment: 1,
  AdjustRate: 2,
  AgencyDiscountType: 3,
};
export const CalculateAdjustments = (newAdjustments, isFromChangeOrder = false) => {
  // const resp = await processAdjustments(newAdjustments);
  // return resp.content.Data;

  let response,
    currentRate,
    index = 1;

  if (newAdjustments) {
    response = {};
    currentRate = parseFloat(newAdjustments.CardRate);
    newAdjustments.Net = parseFloat(currentRate);
    newAdjustments.Gross = parseFloat(currentRate);

    response.Adjustments = [
      {
        DisplayID: -10,
        Name: "Initial Rate",
        ID: -1,
        SortOrder: 1,
        Gross: currentRate,
        Net: currentRate,
        Amount: 0,
        AdjustmentText: "0",
        IsBeforeAgencyDiscount: true,
      },
    ];

    response.Gross = currentRate;
    response.Net = currentRate;

    newAdjustments.Adjustments.forEach((adj) => {
      if (adj.Name !== "Initial Rate") {
        adj.Gross = newAdjustments.Gross;

        if (adj.ID > -1 && adj.IsBeforeAgencyDiscount && adj.DisplayID >= 0) {
          if (!adj.IsSurcharge) {
            if (adj.Amount > 0) {
              adj.Amount *= -1;
            }
            adj.AdjustmentText = adj.Amount.toString();
          }
          if (adj.Percentage > 0) {
            let newAdjValue = GetAdjustmentAmountBasedonPercent(
              currentRate,
              newAdjustments.Net,
              newAdjustments.Gross,
              adj
            );
            adj.Amount =
              !adj.IsSurcharge && newAdjValue > 0
                ? newAdjValue * -1
                : newAdjValue;
          }
          adj.Gross += parseFloat(adj.Amount);
          adj.Net = parseFloat(adj.Gross);
          adj.Gross = adj.Gross > 0 ? adj.Gross : 0;
          adj.Net = adj.Net > 0 ? adj.Net : 0;
          adj.DisplayID = index;
          adj.SortOrder = 2;
          newAdjustments.Gross = adj.Gross;
          newAdjustments.Net = adj.Net;
          response.Gross = parseFloat(adj.Gross).toFixed(2);
          response.Net = parseFloat(adj.Net).toFixed(2);
          response.Adjustments.push(adj);
          index++;
        }
      }
    });

    currentRate = newAdjustments.Gross;

    if (newAdjustments.HasAgencyDiscountApplied) {
      let agencyDiscountAmount = 0;

      if (
        newAdjustments.AgencyDiscountType.toString() === "0" ||
        newAdjustments.AgencyDiscountType === "Gross"
      ) {
        newAdjustments.Net =
          currentRate -
          (newAdjustments.AgencyPercent * newAdjustments.Gross) / 100;
        newAdjustments.Net = Math.round(newAdjustments.Net * 100) / 100;

        // newAdjustments.AgencyPercent =
        //   currentRate !== 0
        //     ? (100 * (currentRate - newAdjustments.Net)) / currentRate
        //     : 0;
        if (!isFromChangeOrder &&  currentRate == 0) {
          newAdjustments.AgencyPercent = 0;
        }

        agencyDiscountAmount =
          (newAdjustments.AgencyPercent * newAdjustments.Gross) / 100;
      } else if (
        newAdjustments.AgencyDiscountType.toString() === "1" ||
        newAdjustments.AgencyDiscountType === "Net+"
      ) {
        newAdjustments.Gross =
          currentRate + (currentRate * newAdjustments.AgencyPercent) / 100;
        newAdjustments.Gross = Math.round(newAdjustments.Gross * 100) / 100;

        // newAdjustments.AgencyPercent =
        //   currentRate !== 0
        //     ? (100 * (newAdjustments.Gross - currentRate)) / currentRate
        //     : 0;
        if (!isFromChangeOrder &&  currentRate == 0) {
          newAdjustments.AgencyPercent = 0;
        }

        agencyDiscountAmount =
          (currentRate * newAdjustments.AgencyPercent) / 100;
      } else {
        newAdjustments.Gross =
          currentRate / ((100 - newAdjustments.AgencyPercent) / 100);
        newAdjustments.Gross = Math.round(newAdjustments.Gross * 100) / 100;

        // newAdjustments.AgencyPercent =
        //   newAdjustments.Gross !== 0
        //     ? 100 - (100 * currentRate) / newAdjustments.Gross
        //     : 0;
        if (!isFromChangeOrder &&  currentRate == 0) {
          newAdjustments.AgencyPercent = 0;
        }

        agencyDiscountAmount =
          (newAdjustments.Gross * newAdjustments.AgencyPercent) / 100;
      }

      newAdjustments.AgencyPercent =
        Math.round(newAdjustments.AgencyPercent * 100) / 100;
      agencyDiscountAmount *= -1;
      response.Gross = parseFloat(
        newAdjustments.Gross > 0 ? newAdjustments.Gross : 0
      ).toFixed(2);
      response.Net = parseFloat(
        newAdjustments.Net > 0 ? newAdjustments.Net : 0
      ).toFixed(2);

      let adjustment = newAdjustments.Gross - newAdjustments.Net;
      adjustment = Math.round(adjustment * 100) / 100;

      newAdjustments.Adjustments = newAdjustments.Adjustments.filter(
        (agencyDiscount) => agencyDiscount.DisplayID !== -20
      );

      response.Adjustments.push({
        DisplayID: -20,
        ID: -1,
        Name: newAdjustments.AgencyPercent.toString() + "% Agency Discount",
        AdjustmentText: "-" + adjustment.toString(),
        Percentage: parseFloat(newAdjustments.AgencyPercent),
        Gross: newAdjustments.Gross,
        Net: newAdjustments.Net,
        SortOrder: 3,
        Amount: parseFloat(agencyDiscountAmount),
      });
    }

    newAdjustments.Adjustments.forEach((adj) => {
      if (adj.ID > -1 && !adj.IsBeforeAgencyDiscount) {
        adj.AdjustmentText = adj.Amount.toString();
        if (!adj.IsSurcharge) {
          if (adj.Amount > 0) {
            adj.Amount *= -1;
          }
          adj.AdjustmentText = adj.Amount.toString();
        }
        if (adj.Percentage > 0) {
          let tempAdjustmentValue = GetAdjustmentAmountBasedonPercent(
            currentRate,
            newAdjustments.Net,
            newAdjustments.Gross,
            adj
          );
          adj.Amount =
            !adj.IsSurcharge && tempAdjustmentValue > 0
              ? tempAdjustmentValue * -1
              : tempAdjustmentValue;
        }
        adj.Net = newAdjustments.Net + parseFloat(adj.Amount);
        adj.Net = Math.round((adj.Net > 0 ? adj.Net : 0) * 100) / 100;
        adj.SortOrder = 4;
        adj.Gross = newAdjustments.Gross;
        adj.DisplayID = index;
        newAdjustments.Net = adj.Net;
        response.Gross = parseFloat(adj.Gross).toFixed(2);
        response.Net = parseFloat(adj.Net).toFixed(2);
        response.Adjustments.push(adj);
        index++;
      }
    });
  } else {
    response = {
      Net: newAdjustments.CardRate,
      Gross: newAdjustments.CardRate,
      Adjustments: [
        {
          DisplayID: -10,
          Name: "Initial Rate",
          ID: -1,
          SortOrder: 1,
          Gross: newAdjustments.CardRate,
          Net: newAdjustments.CardRate,
          Amount: 0,
          IsBeforeAgencyDiscount: true,
        },
      ],
    };
  }

  return response;
};
export const GetAdjustmentAmountBasedonPercent = (
  cardRate,
  Net,
  Gross,
  Adjustment
) => {
  let currentRate = Adjustment.IsBeforeAgencyDiscount
    ? parseFloat(Gross || 0)
    : parseFloat(Net || 0);
  const percentage = parseFloat(Adjustment.Percentage);
  let adjustmentAmount;
  if (Adjustment.IsStacked) {
    adjustmentAmount = ((currentRate * percentage) / 100).toFixed(2);
  } else {
    const rateToUse = Adjustment.IsBeforeAgencyDiscount
      ? parseFloat(cardRate || 0)
      : parseFloat(Gross || 0);
    adjustmentAmount = ((rateToUse * percentage) / 100).toFixed(2);
  }
  return adjustmentAmount;
};
export const defaultLoadingStatus = { isLoading: false, loadingText: null };
//for showing alert in create order
export const NoBusinessUnit =
  "No business units have been set up for this product type. Please contact your administrator to have them set up.";
export const NoProduct =
  "No products have been set up for this product type. Please contact your administrator to have them set up.";
export const plusBtnAllowedFields = [
  "adcolor",
  "adfrequency",
  "adposition",
  "adsize",
  "specialsection",
];
export const getDayIndex = (day) => {
  const dayIndices = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };
  return dayIndices[day] !== undefined ? dayIndices[day] : -1;
};

export const getDayFromIndex = (day) => {
  return DaysOfWeek[day];
};

export const getLastWeekDate = (date, dayOfWeek) => {
  // Function to get the last occurrence of a specific dayOfWeek in a month
  const firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
  const lastDayOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  let lastWeekDate = null;
  for (
    let d = lastDayOfMonth;
    d >= firstDayOfMonth;
    d.setDate(d.getDate() - 1)
  ) {
    if (d.getDay() === dayOfWeek) {
      lastWeekDate = new Date(d);
      break;
    }
  }

  return lastWeekDate;
};

export const getNthWeekdayOfMonth = (date, nth, weekday) => {
  let tempDate = new Date(date.getFullYear(), date.getMonth(), 1);
  let count = 0;
  while (tempDate.getDay() !== weekday) {
    tempDate.setDate(tempDate.getDate() + 1);
  }
  while (count < nth - 1) {
    tempDate.setDate(tempDate.getDate() + 7);
    count++;
  }
  return tempDate;
};

export const getFilteredIssues = (filterData, startDate, endDate, issues) => {
  let filteredIssues = [];
  switch (filterData.selectedFrequency) {
    case "All":
      filteredIssues = issues.filter(
        (issue) =>
          new Date(issue.Date).getTime() >= startDate.getTime() &&
          new Date(issue.Date).getTime() <= endDate.getTime()
      );
      break;
    case "Daily":
      let currentDate = new Date(startDate);
      while (currentDate <= new Date(endDate)) {
        const formattedDate = formatDate(currentDate, getDbDateFormat());
        const filtered = issues.filter(
          (issue) =>
            formatDate(new Date(issue.Date), getDbDateFormat()) ===
            formattedDate
        );
        filteredIssues.push(...filtered);
        currentDate.setDate(
          currentDate.getDate() + Number(filterData.dailyInterval)
        );
      }
      break;
    case "Weekly":
      let weekStartDate = new Date(startDate);
      while (weekStartDate <= endDate) {
        for (let j = 0; j <= 6; j++) {
          let currentDay = new Date(weekStartDate);
          currentDay.setDate(weekStartDate.getDate() + j);
          if (currentDay > endDate) {
            break;
          }
          const filteredWeeklyIssue = issues.find(
            (issue) =>
              formatDate(new Date(issue.Date), getDbDateFormat()) ===
              formatDate(currentDay, getDbDateFormat())
          );
          if (
            filterData.selectedDaysOfWeek.includes(
              getDayFromIndex(currentDay.getDay())
            ) &&
            filteredWeeklyIssue
          ) {
            filteredIssues.push(filteredWeeklyIssue);
          }
        }
        weekStartDate.setDate(
          weekStartDate.getDate() + 7 * Number(filterData.weeklyInterval)
        );
      }
      break;
    case "Monthly":
      let monthStartDate = new Date(startDate);
      while (monthStartDate <= new Date(endDate)) {
        const monthEndDate = new Date(
          monthStartDate.getFullYear(),
          monthStartDate.getMonth() + 1,
          0
        );
        let dayOfMonth;
        if (filterData.monthlyWeek.toLowerCase() === "last") {
          dayOfMonth = getLastWeekDate(
            monthStartDate,
            getDayIndex(filterData.monthlyDay)
          );
        } else {
          dayOfMonth = getNthWeekdayOfMonth(
            monthStartDate,
            filterData.monthlyWeek,
            getDayIndex(filterData.monthlyDay)
          );
        }
        if (dayOfMonth <= monthEndDate && dayOfMonth >= monthStartDate) {
          const filtered = issues.filter(
            (issue) =>
              formatDate(new Date(issue.Date), getDbDateFormat()) ===
              formatDate(dayOfMonth, getDbDateFormat())
          );
          filteredIssues.push(...filtered);
        }
        monthStartDate.setMonth(monthStartDate.getMonth() + 1);
      }
      break;
    default:
      filteredIssues = issues;
      break;
  }
  return filteredIssues;
};

export const userChoices = {
  UseNextRateCard: false,
  UseCurrentRateCard: false,
  UseRateCardBasedOnRunDate: false,
};

export const positions = [
  "Above Title",
  "Below Title",
  "Above Text",
  "Below Text",
  "Above Footer",
  "Below Footer",
];

// Panel Types

const PanelTypes = {
  SidePanel: SidePanel,
  Modal: Modal,
};

export const OrderEntryPanelTypes = {
  ORDER_SUMMARY: "ORDER_SUMMARY",
  INVENTORY_CHECK: "INVENTORY_CHECK",
  GAM: "GAM",
  INVENTORY_FORECAST: "INVENTORY_FORECAST",
  COPY_ISSUES: "COPY_ISSUES",
  LINKED_RATE_CARD: "LINKED_RATE_CARD",
  DATE_RANGE: "DATE_RANGE",
  BILLING: "BILLING",
  SPLIT: "SPLIT",
  INVOICE_TEMPLATE: "INVOICE_TEMPLATE",
  ACTION_PANEL: "ACTION_PANEL",
  AD_MASTER_EDIT: "AD_MASTER_EDIT",
  QUICK_PAY_DATES: "QUICK_PAY_DATES",
};

export const invRequiredColumns = [
  "AdSize",
  "Position",
  "Product",
  "Issue",
  "MaxInv",
  "Inventory",
];

const formHeaderAndAccessorOfInvLimit = (column, columnsWidth) => {
  switch (column) {
    case "AdSize":
      return {
        Header: "AdSize",
        accessor: "AdSize.Name",
        width: columnsWidth,
      };
    case "Position":
      return {
        Header: "Position",
        accessor: "AdPosition.Name",
        width: columnsWidth,
      };
    case "Product":
      return {
        Header: "Product",
        accessor: "Product.Name",
        width: columnsWidth,
      };
    case "Issue":
      return { Header: "Issue", accessor: "Issue.Name", width: columnsWidth };
    case "MaxInv":
      return { Header: "Status", accessor: "Status", width: columnsWidth };
    case "Inventory":
      return { Header: "Inventory", accessor: "Custom", width: columnsWidth };
    default:
      return null;
  }
};
export const formColumnHeaders = (ColumnList, tableRef, width = 0) => {
  let columns = ColumnList;
  // const containerWidth = tableRef.current && tableRef.current.getBoundingClientRect().width;
  // let columnsWidth = (containerWidth - 2)/(columns.length)
  return columns.map((column) => {
    return formHeaderAndAccessorOfInvLimit(column, 150);
  });
};

export const openOrderEntryPage = (
  orderId = -1,
  ProposalId = -1,
  ContactID,
  SubProductTypeID,
  openInSameTab=false,
  mode = "edit",
  isPA = false,
  productTypeName = "",
  additionalParams = {}
) => {
  const {
    containerID = -1,
    PAadvertiserID = -1,
    pagesource = "",
    showbetaicon = true
  } = additionalParams;

  const queryParams = new URLSearchParams({
    ContactID,
    SubProductTypeID,
    ID: orderId,
    ProposalID: ProposalId,
    ispa: isPA,
    name: productTypeName,
    containerid: containerID,
    advertiserid: PAadvertiserID,
    pagesource,
    showbetaicon
  }).toString();

  if(mode==="create" && isPA){
    window.open(
      `${Page_PA_Orders_Landing}/create?${queryParams}`, openInSameTab ? "_self" : "_blank"
    );
  }
  else{
    window.open(
      `${Page_Orders_Landing}/${mode}?${queryParams}`, openInSameTab ? "_self" : "_blank"
    );
  }
};

export const getDetailsSectionFieldCode = (field) => {
  switch (field) {
    case "adsize":
      return "AdSize";
    case "adposition":
      return "AdPosition";
    case "adcolor":
      return "AdColor";
    case "adfrequency":
      return "AdFrequency";
    case "specialsection":
      return "SpecialSection";
  }
};

export const renderTags = (tagData = {}) => (
  <>
    {Object.entries(tagData).map(([label, tag]) =>
      tag.visible ? (
        <span key={label} className={`inv-count ${tag.className}`}>
          {formatNumber(tag.count, 2)}
        </span>
      ) : null
    )}
  </>
);
